let  BASE_URL = "https://doit-activation.de";
import axios from 'axios'
import { Notify } from 'quasar'
import storage from "./storage"
if(window.location.hostname=="promoter.doit-activation.de"){
  BASE_URL= "https://promoter.doit-activation.de";
}

if(window.location.hostname=="10.10.0.25"){
  //  BASE_URL= "https://dev.doit-activation.de";
}
console.log("window.location:"+window.location.hostname+" => BASE_URL: "+BASE_URL)

axios.interceptors.request.use(
  (request) => {

    request.credentials = true
    let user = storage.get("user");
    if (user !== null && typeof (user) != "undefined") {
      request.headers['x-session-token'] = user.jwt;
    }

    let promoter = storage.get("promoter");
    if (promoter !== null && typeof (promoter) != "undefined") {
      request.headers['x-session-promotertoken'] = promoter.jwt;
    }


    let kunde = storage.get("kunde");
    if (kunde !== null && typeof (kunde) != "undefined") {
      request.headers['x-session-kundetoken'] = kunde.jwt;
    }


    return request;
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {

    console.log("error")
    console.log(error)

    Notify.create(error.response.data.error.message + "  (" + error.response.status + ") ");

    if (error.response.status == 401) {
      console.log("Leite um zum Login");
      localStorage.removeItem("user");
      localStorage.removeItem("promoter");
      xstore.state.user = false
      xstore.state.promoter = false

      router.push("/login");
    }

    console.log("Response Error")
    console.log(error.response.status);
    console.log(error.response);
    return Promise.reject(error);
  }
);


export default ({

  post: async (url, data) => {
    const result = await axios.post(BASE_URL + url, data)
    // console.log("result:" ,result)
    if (result.data.error) {
      Notify.create(result.data.error);
      return false;
    }
    return result.data

  },
    post_blob: async (url, data) => {
    const result = await axios.post(BASE_URL + url, data, { responseType: 'blob' })
    // console.log("result:" ,result)
    if (result.data.error) {
      Notify.create(result.data.error);
      return false;
    }
    return result.data

  },

  get: async (url) => {
    const result = await axios.get(BASE_URL + url )
    console.log("result:", result)
    if (result.data.error) {
      Notify.create(result.data.error.message);
      return false;
    }
    return result.data

  },
   get_blob: async (url) => {
    const result = await axios.get(BASE_URL + url, { responseType: 'blob' })
    console.log("result blob:", result)
    if (result.data.error) {
      Notify.create(result.data.error.message);
      return false;
    }
    return result.data

  },
  post_cb: (url, data, callback) => {
    axios.post(BASE_URL + url, data)
        .then((response) => {
            // console.log("1211")
            if (response.data.error) {
              Notify.create(response.data.error);
            }

            callback(response.data)
        })
        .catch(function (error) {
            // handle error
            console.log(error);
        })
},







})
